"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useAsyncThrottler = require("./useAsyncThrottler.cjs");
function useAsyncThrottledCallback(fn, options) {
  const asyncThrottledFn = useAsyncThrottler.useAsyncThrottler(fn, options).maybeExecute;
  return react.useCallback(
    (...args) => asyncThrottledFn(...args),
    [asyncThrottledFn]
  );
}
exports.useAsyncThrottledCallback = useAsyncThrottledCallback;
//# sourceMappingURL=useAsyncThrottledCallback.cjs.map
